import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-navbar-nav',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <nav class="navbar-nav">
      @if(this.isLoggedIn) {
        <a 
          [routerLink]="'/'" 
          class="nav-item" 
          [class.active]="currentRoute === '/'">
          Home
        </a>
        <a 
          [routerLink]="'/admin'" 
          class="nav-item" 
          [class.active]="currentRoute.startsWith('/admin')">
          Admin
        </a>

        @if(this.isAdmin) {
          <a 
            [routerLink]="'/users'" 
            class="nav-item" 
            [class.active]="currentRoute === '/users'">
            Users
          </a>
        }
      }
      
    </nav>
  `,
  styles: [`
    .navbar-nav {
      display: flex;
      align-items: center;
      gap: 2rem;
      margin-left: 2rem;
    }
    
    .nav-item {
      text-decoration: none;
      color: #021d7f;
      font-weight: 500;
      font-size: 1rem;
      padding: 0.5rem 0;
      border-bottom: 2px solid transparent;
      transition: border-bottom-color 0.2s ease;
      cursor: pointer;
    }
    
    .nav-item:hover {
      border-bottom-color: #021d7f;
    }
    
    .nav-item.active {
      border-bottom-color: #021d7f;
      font-weight: 600;
    }
  `]
})
export class NavbarNavComponent implements OnInit, OnDestroy {
  currentRoute = '';
  isAdmin = false;
  isLoggedIn = false;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private authService: AuthService
  ) {
    this.currentRoute = this.router.url;
    
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.urlAfterRedirects;
      });
  }

  async ngOnInit(): Promise<void> {
    await this.checkUserType();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private async checkUserType(): Promise<void> {
    try {
      const user = await this.authService.getUser();
      this.isLoggedIn = !!user?.email;
      this.isAdmin = user?.userType === 'admin';
    } catch (error) {
      this.isAdmin = false;
      this.isLoggedIn = false;
    }
  }
}